import { cn } from "@/lib/utils";
import { ArrowUp, Zap } from "lucide-react";
import { STATUS_COLORS } from "@/lib/colorsMap";

export function TaskPlaceholderItem({
  task,
  statuses = [],
  onGoToTask,
  className,
  ...props
}) {
  // Look up the status config to get the color
  const statusConfig = statuses.find(s => s.id === task.status?.id);

  return (
    <div
      className={cn(
        "group relative flex items-center gap-3 px-3 py-2 rounded-md transition-all duration-200",
        // Minimal ghost styling
        "border border-dashed border-neutral-200/60 dark:border-neutral-700/60",
        "bg-neutral-50/30 dark:bg-neutral-900/20",
        "hover:border-neutral-300/80 dark:hover:border-neutral-600/80",
        "hover:bg-neutral-100/40 dark:hover:bg-neutral-800/25",
        "cursor-pointer select-none h-8",
        className
      )}
      onClick={(e) => {
        e.stopPropagation();
        if (onGoToTask) {
          onGoToTask(task);
        }
      }}
      {...props}
    >
            {/* Minimal ghost content - better horizontal layout */}
            <div className="flex items-center gap-3 flex-1 min-w-0">
              {/* Left section: Task key and status */}
              <div className="flex items-center gap-2 shrink-0">
                <span className="text-xs font-mono text-neutral-400 dark:text-neutral-500 bg-neutral-100/50 dark:bg-neutral-800/30 px-1.5 py-0.5 rounded text-center">
                  {task.key}
                </span>
                <div className={cn(
                  "w-2 h-2 rounded-full opacity-60",
                  STATUS_COLORS[statusConfig?.color]?.bg || "bg-neutral-400"
                )}></div>
              </div>
              
              {/* Middle section: Task summary */}
              <span className="text-xs text-neutral-400 dark:text-neutral-500 truncate flex-1">
                {task.summary}
              </span>
              
              {/* Right section: Active indicator and assignee */}
              <div className="flex items-center gap-2 shrink-0">
                <div className="flex items-center gap-1 text-xs text-neutral-400 dark:text-neutral-500 bg-neutral-100/30 dark:bg-neutral-800/20 px-2 py-0.5 rounded">
                  <Zap className="h-3 w-3" />
                  <span>in active week</span>
                </div>
                {task.assignee && (
                  <div className={cn(
                    "w-4 h-4 rounded-full flex items-center justify-center text-xs font-medium text-white",
                    task.assignee.avatarColor,
                    "opacity-60"
                  )}>
                    {task.assignee.initials}
                  </div>
                )}
              </div>
            </div>

            {/* Up arrow indicator */}
            <div className="h-6 w-6 flex items-center justify-center shrink-0">
              <ArrowUp className="h-3 w-3 text-neutral-400 dark:text-neutral-500 group-hover:text-neutral-700 dark:group-hover:text-neutral-300 transition-colors duration-200" />
            </div>
    </div>
  );
} 